import { FC } from 'react';
import { Line } from "react-chartjs-2";
import styled from "styled-components/macro";
import { useTheme } from "@material-ui/core";
import moment from "moment";
import { useTranslation } from "react-i18next";
type PropsType = {
  data: {
    [key: string]: number
  }
}
const LineChart: FC<PropsType> = ({data}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const ChartWrapper = styled.div`
        height: 230px;
     `;

  const labels = data ? Object.keys(data).map(
    (d) => moment(Number(d)).format("D MMM")) : []

  const dataChart = {
    labels: labels,
    datasets: [
      {
        label: `${t("statsPage_amount")}:`,
        fill: true,
        backgroundColor: "transparent",
        borderColor: theme.palette.secondary.main,
        data: data ? Object.values(data) : []
      },
    ],
  };

  const optionsChart = {
    animation: {
      duration: 0
    },
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    tooltips: {
      intersect: false,
    },
    hover: {
      intersect: true,
    },
    plugins: {
      filler: {
        propagate: false,
      },
    },
    scales: {
      xAxes: [
        {
          reverse: true,
          gridLines: {
            color: "rgba(0,0,0,0.05)",
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            stepSize: 500,
          },
          display: true,
          borderDash: [5, 5],
          gridLines: {
            color: "rgba(0,0,0,0)",
            fontColor: "#fff",
          },
        },
      ],
    },
  };

  return (
    <ChartWrapper>
      <Line data={dataChart} options={optionsChart} />
    </ChartWrapper>
  );
}
export default LineChart